import React from 'react';
import { Modal, Button } from 'react-bootstrap';

interface ResetPasswordModalProps {
  show: boolean;
  onHide: () => void;
  resetEmpId: string;
  handleResetPassword: () => void;
  loading: boolean;
}

const ResetPasswordModal: React.FC<ResetPasswordModalProps> = ({
  show,
  onHide,
  resetEmpId,
  handleResetPassword,
  loading,
}) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Reset Password</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to reset the password for user with employee ID:{' '}
          <strong>{resetEmpId}</strong>?
        </p>
        <p>This will reset the user password to the default password.</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleResetPassword} disabled={loading}>
          Reset
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetPasswordModal;